import { createFileRoute } from '@tanstack/react-router';
import { RelatorioVenda } from '@/features/relatorio/page/venda/RelatorioVenda';

export const Route = createFileRoute('/a/relatorio/venda/')({
    component: RelatorioVenda,
});
